import React from 'react';
import { useStore } from '../../../../../stores/root';

// assets

// services
import VendorsService from '../../../../../services/data/vendors';

// props

// components
import { DefaultButton, Link, Panel, PanelType, PrimaryButton, SearchBox, Stack } from '@fluentui/react';
import Text from '../../../../typography/text';
import { IVendorResourceShortProps } from '../../../../../props/data/vendors';
import LoadingComponent from '../../../../feedbacks/loading';
import Label from '../../../../typography/label';

type SearchVendorFormProps = {
    onDismissed(): void;
    onCreateNew(name: string): void;
}

const SearchVendorForm: React.FC<SearchVendorFormProps> = (props: SearchVendorFormProps) => {
    const { banner, user } = useStore();
    const [searching, setSearching] = React.useState<boolean>(false);
    const [keyword, setKeyword] = React.useState<string>("");
    const [similarNames, setSimilarNames] = React.useState<string[]>([]);

    const _onSearch = async (value?: string) => {
        setSearching(true);
        setKeyword(value || "");

        if (value && value.trim() !== "") {
            try {
                const [_similarNames, _vendors] = await Promise.all([
                    ((await VendorsService.findSimilar(`name=${value}`)) || []), 
                    (await VendorsService.retrieve(["search=" + value, "top=all"].join("&")))
                ]);

                const _loweredCaseNames: string[] = JSON.parse(JSON.stringify(_similarNames || [])).map((name: string) => name.toLowerCase());
                _vendors.data.forEach((vendor) => {
                    if (_loweredCaseNames.indexOf(vendor.name.toLowerCase()) < 0) {
                        _similarNames.push(vendor.name)
                    }
                });

                setSimilarNames(_similarNames);
                setSearching(false);
            } catch(e) {}
        }
    }

    const _onRenderVendorName = (name: string) => {
        return <Stack className={'card'}>
            <Label size={'xsmall'}>{name}</Label>
        </Stack>
    }

    return <Panel headerText={'Create Vendor'}
        isOpen={true}
        type={PanelType.medium}
        onDismiss={() => props.onDismissed()}
        onRenderFooterContent={() => {
            return <Stack horizontal tokens={{ childrenGap: 10 }}>
                <DefaultButton text={"Cancel"} onClick={() => { props.onDismissed() }} />
            </Stack>;
        }}
        isFooterAtBottom={true} >
        <Stack tokens={{childrenGap: 15}}>
            <Text>To ensure no vendors are created multiple times, please type in vendor name that you are going to add to make sure it's not yet in the system.</Text>
            <SearchBox placeholder='Search vendor ...'
                value={keyword}
                onChange={(evt, value) => {
                    setKeyword(value || "");
                }}
                onSearch={_onSearch} />
            {searching ? <Stack className={'divider'} /> : null}
            {searching ? <LoadingComponent label={'Searching ...'} labelPosition={'right'} spinnerPosition={'baseline'} /> : null}
            {!searching && keyword.length > 0 && similarNames.length < 1 ? <Stack tokens={{childrenGap: 15}}>
                <Stack className={'divider'} />
                <Text size={'small'}>No vendor found. <Link onClick={() => props.onCreateNew(keyword)}>click here</Link> to create new vendor.</Text>
            </Stack> : null}
            {!searching && keyword.length > 0 && similarNames.length > 0 ? <Stack tokens={{childrenGap: 15}}>
                <Stack className={'divider'} />
                <Text size={'small'}>{similarNames.length} vendors with similar name found</Text>
                {similarNames.map(_onRenderVendorName)}
                <Stack className={'divider'} />
                <Text size={'small'}>If you cannot find vendors that you are looking for, <Link onClick={() => props.onCreateNew(keyword)}>click here</Link> to create new vendor.</Text>
            </Stack> : null}
        </Stack>
    </Panel>;
};

export default SearchVendorForm;
